var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-confirm-page"},[_c('div',{staticClass:"bg-image-wrapper"},[_c('img',{staticClass:"bg-image",attrs:{"src":require('@/assets/order_pending.svg'),"alt":""}})]),_c('ByFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }